import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=06b6c172&scoped=true"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"
import style0 from "./addPage.vue?vue&type=style&index=0&id=06b6c172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6c172",
  null
  
)

export default component.exports